import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { House, List, User, Info, Robot } from '@phosphor-icons/react';
import CreditModal from './CreditModal';

function GNB() {
  const location = useLocation();
  const [isCreditModalOpen, setIsCreditModalOpen] = useState(false);

  const isActive = (path) => {
    return location.pathname === path ? 'text-primary font-bold' : 'text-gray-400 hover:text-gray-600';
  };

  return (
    <>
      <nav className="fixed bottom-0 left-0 right-0 bg-white/80 backdrop-blur-lg border-t border-gray-200 z-50 pb-safe">
        <div className="flex justify-around items-center h-16 max-w-md mx-auto">
          <Link to="/" className={`flex flex-col items-center transition-colors ${isActive('/')}`}>
            <House size={24} weight={location.pathname === '/' ? 'fill' : 'duotone'} className="mb-1" />
            <span className="text-[10px]">홈</span>
          </Link>
          <Link to="/teacher-dashboard" className={`flex flex-col items-center transition-colors ${isActive('/teacher-dashboard')}`}>
            <List size={24} weight={location.pathname === '/teacher-dashboard' ? 'fill' : 'duotone'} className="mb-1" />
            <span className="text-[10px]">내 퀴즈</span>
          </Link>
          <Link to="/ai-quiz" className={`flex flex-col items-center transition-colors ${isActive('/ai-quiz')}`}>
            <Robot size={24} weight={location.pathname === '/ai-quiz' ? 'fill' : 'duotone'} className="mb-1" />
            <span className="text-[10px]">AI 퀴즈</span>
          </Link>
          <Link to="/profile" className={`flex flex-col items-center transition-colors ${isActive('/profile')}`}>
            <User size={24} weight={location.pathname === '/profile' ? 'fill' : 'duotone'} className="mb-1" />
            <span className="text-[10px]">내 정보</span>
          </Link>
          <button
            onClick={() => setIsCreditModalOpen(true)}
            className="flex flex-col items-center text-gray-400 hover:text-gray-600 transition-colors"
          >
            <Info size={24} weight="duotone" className="mb-1" />
            <span className="text-[10px]">앱 정보</span>
          </button>
        </div>
      </nav>
      <CreditModal isOpen={isCreditModalOpen} onClose={() => setIsCreditModalOpen(false)} />
    </>
  );
}

export default GNB;